
export class Form
{

  private readonly formSelector: string;

  constructor(formSelector: string) {

    this.formSelector = formSelector;
    const formElement = document.querySelector(formSelector);
    if (!formElement) return;

    // 入力要素の監視
    this.typedInputs('input, textarea, select');

    // Validate
    const $form = $(this.formSelector);
    const check = (el: Element): void => {
      let $el = $(el).parents('[data-config]');
      this.validateInput($el);
    };

    // テキストボックス
    const $texts = $('[data-config] input, [data-config] textarea', $form);
    $texts.each((i, el): void => {
      $texts[i].addEventListener('blur', () => { check(el); });
    });

    // チェックボックス
    const $checks = $('[data-config] input[type="checkbox"]', $form);
    $checks.each((i, el): void => {
      $checks[i].addEventListener('blur', () => { check(el); });
      $checks[i].addEventListener('change', () => { check(el); });
    });

    // 送信ボタン
    const submitButton = document.querySelector(this.formSelector + ' button[type="submit"]');
    if (!submitButton) return;
    const submitButtonEvent = (e: Event): void => {
      e.preventDefault();
      if( this.validateForm() ) {
        $form.submit();
      }
    };
    submitButton.addEventListener('click', submitButtonEvent);
  }

  private typedInputs(selectors: string) {
    const inputElements = document.querySelectorAll(selectors);
    if (!inputElements) return;

    const focus = (el: Element): void => {
      el.classList.add('is-typed');
    };
    inputElements.forEach((el: Element) => {
      el.addEventListener('focus', () => { focus(el); });
    });
  }

  private validateForm() {
    let ret = true;
    const $inputs = $('[data-config]', $(this.formSelector));
    $inputs.each((i) => {
      if(!this.validateInput($inputs[i])){
        ret = false;
      }
    });
    return ret;
  }

  private validateInput(el: any) {
    let val = $('[name]', el).val();
    let config = $(el).data('config');
    let flag = true;
    // 必須チェック
    if(config.required === true){
      // まず全体チェック
      if(val === '') flag = false;
      // 入力グループの必須チェック
      $('[data-input-group] input', el).each(function(i, el) {
        if($(el).val() === '' && $(el).hasClass('typed')){
          flag = false;
        }
      });
      if(flag === false){
        $('[data-message]', el).text(config.requiredError);
        $(el).addClass('is-error');
        return false;
      }
    }
    // チェックボックスのチェック
    if(config.checked === true){
      if(!$('[type="checkbox"]:checked, [type="radio"]:checked', el).val()){
        $('[data-message]', el).text(config.checkedError);
        $(el).addClass('is-error');
        return false;
      }
    }
    // 正規表現チェック
    if(config.type !== ''){
      let regex: string | undefined = $(el).attr('data-regex');
      if (typeof regex === "string" && typeof val === "string") {
        if(regex != '' && !val.match(regex)){
          $('[data-message]', el).text(config.typeError);
          $(el).addClass('is-error');
          return false;
        }
      }
    }
    $('[data-message]', el).text('');
    $(el).removeClass('is-error');
    return true;
  }
}
